module.exports = __webpack_public_path__ + "static/media/p5_3.af73d56d.jpeg";